import { Injectable } from '@angular/core';
import { ArcService } from './arc.service';

@Injectable()
export class FileService {
  filesMap = new Map<string, Object[]>();
  private _uploadForms = new Set<string>();

  constructor(private arcs: ArcService) { }

  newFromSaved(obj: Object, cancelUploadForm?: boolean) {
    let tpl = obj['filename'].split('/');
    let fn = tpl[tpl.length - 1];
    let p = tpl[tpl.length - 2];
    let i = fn.lastIndexOf('@');
    let parentId;


    if (i < 0) {
      parentId = p;
    } else {
      parentId = fn.slice(i + 1);
      i = parentId.lastIndexOf('.');
      if (i > 0) {
        parentId = parentId.slice(0, i);
      }
    }

    let ls = this.filesMap.get(parentId);
    if (!ls) {
      ls = [];
      this.filesMap.set(parentId, ls);
    }
    ls.push({
      project: p,
      parentId: parentId,
      gae: obj['filename'],
      path: `https://gae-test.ecomole.com/s/r/SearchManagerFiles/${p}/${fn}`,
      filename: fn,
      size: Math.round(obj['st_size'] / 100) / 10
    });
    if (cancelUploadForm) {
      this._uploadForms.delete(`${p}::${parentId}`);
    }
  }

  files(pid: string, projectShortcut: string) {
    return this.filesMap.get(pid) || [];
  }

  isUploadForm(uid: string) {
    return this._uploadForms.has(uid);
  }

  switchUploadForm(uid: string) {
    if (!this._uploadForms.delete(uid)) {
      this._uploadForms.add(uid);
    }
  }

  deleteFile(f: Object) {
    let obs = this.arcs.run({
      fun: 'deleteFile',
      path: f['gae']
    });
    obs.subscribe(x => {
      let ls = this.filesMap.get(f['parentId']);
      let i;
      ls.forEach((y, j) => {
        if (y['gae'] === f['gae']) {
          i = j;
        }
      });
      ls.splice(i, 1);
    });
    return obs;
  }

}



// WEBPACK FOOTER //
// ./src/app/file.service.ts